import { confirmAction } from '@/components/ui';

/**
 * V3-003 (C4, V2-016 #8): the server refuses an approve whose total differs from the saved one
 * with 409 `HE_AMOUNT_CHANGED` and both amounts. Every approve path (card Approve and send /
 * without sending, Operations Coordinator submit-and-approve) shows this one dialog.
 */
export const HE_AMOUNT_CHANGED = 'HE_AMOUNT_CHANGED';

export interface AmountChange {
  displayedTotal: number;
  serverTotal: number;
}

/** The two amounts from a 409 body, or null when the body is anything else. */
export function readAmountChange(status: number | undefined, body: unknown): AmountChange | null {
  if (status !== 409 || !body || typeof body !== 'object') return null;
  const b = body as Record<string, unknown>;
  if (b.code !== HE_AMOUNT_CHANGED) return null;
  const displayedTotal = Number(b.displayedTotal);
  const serverTotal = Number(b.serverTotal);
  if (!Number.isFinite(displayedTotal) || !Number.isFinite(serverTotal)) return null;
  return { displayedTotal, serverTotal };
}

/** $2,211.45 (FMT money format). */
export function formatAmountChangedMoney(value: number): string {
  const abs = Math.abs(value).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${value < 0 ? '-' : ''}$${abs}`;
}

/** Exact wording from the change order: *You saw $2,211.45. It is now $2,012.45.* */
export function amountChangedMessage(change: AmountChange): string {
  return `You saw ${formatAmountChangedMoney(change.displayedTotal)}. It is now ${formatAmountChangedMoney(change.serverTotal)}.`;
}

/** Resolves true for *Approve New Amount*, false for Cancel. */
export function confirmAmountChanged(change: AmountChange): Promise<boolean> {
  return confirmAction({
    title: 'Amount Has Changed',
    body: amountChangedMessage(change),
    confirmLabel: 'Approve New Amount',
    cancelLabel: 'Cancel',
  });
}
